export function accordion() {
    $('#accordion .tab-head').each(function (indx, element) {
        var _collapse = $('#collapse-' + ++indx),
            _height = _collapse.height();

        _collapse.attr('data-height', _height);
        _collapse.height(0);
    });

    $('.tab-head').css('height', 'auto');

    $('.accordion-tab').on('click', function() {
        var _tabs       = $(".accordion-tab span");
        var _tab        = $(this).siblings(".tab-collapse");
        var _tab_span   = $(this).children("span");         
        
        if (_tab_span.hasClass('on')) {
            _tab_span.removeClass('on');
            _tab.height(0);
        } else {            
            if(_tabs.hasClass('on') && $(document).width() >= 768) {
                $(".accordion-tab span").removeClass('on');
                $(".tab-collapse").height(0);
            }
            _tab_span.addClass('on');
            _tab.height(_tab.data('height'));
        }       
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js